var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"87","height":"87","fill":"white","key":0}),React.createElement("path",{"opacity":"0.7","d":"M61.5 39.9019C63.5 41.0566 63.5 43.9434 61.5 45.0981L33.75 61.1196C31.75 62.2743 29.25 60.8309 29.25 58.5215L29.25 26.4785C29.25 24.1691 31.75 22.7258 33.75 23.8805L61.5 39.9019Z","fill":"#BEA169","key":1})]);
}

Play.defaultProps = {"width":"87","height":"87","viewBox":"0 0 87 87","fill":"none"};

module.exports = Play;

Play.default = Play;
